import script from "./federal_groups.vue?vue&type=script&setup=true&lang=js"
export * from "./federal_groups.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__